"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProductIconContainer = _interopRequireDefault(require("../../components/common/ProductIcon/ProductIconContainer"));
var _get = _interopRequireDefault(require("lodash/get"));
var _numberFormatter = require("../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RatesGrid = function RatesGrid(_ref) {
  var productsList = _ref.productsList,
    rates = _ref.rates;
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "right"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, t("Today's Estimated Rates")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rates-grid"
  }, productsList.filter(function (i) {
    return (0, _get["default"])(rates, [i.ProductId, 'IsEnabled'], false);
  }).map(function (i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "rates-grid-item",
      key: i.ProductFullName
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
      product: i,
      iconFileName: i.iconFileName,
      size: 48
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, /*#__PURE__*/_react["default"].createElement("span", null, i.ProductSymbol), /*#__PURE__*/_react["default"].createElement("span", null, i.ProductFullName))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "rate"
    }, "".concat((0, _numberFormatter.formatNumberToLocale)(rates[i.ProductId].Rate, 2), "%"))));
  })));
};
var _default = exports["default"] = RatesGrid;